var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"info"},[_vm._v("是否授权登录")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleAuthorize}},[_vm._v("授权登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }